import React from 'react';
import { IGiactResponse } from 'types/order/escrow/request/IGiactRequest';
import { BodyTextTW, BoldBodyTextTW } from 'tailwindComponents/bodyText/BodyTextTW';

interface IGiactVerificationResponse {
  data: IGiactResponse;
}

export const GiactVerificationResponse: React.FC<IGiactVerificationResponse> = ({ data }) => {
  return (
    <div className={'w-96'}>
      <BoldBodyTextTW className={'pb-2'}>Verification Result: {data.giactStatus}</BoldBodyTextTW>
      <div className={'border-b-2 border-gray-300'} />
      <div className={'flex flex-row py-2'}>
        <BodyTextTW>
          <b className={'mr-1'}>Verification Description:</b>
          {data.description}
        </BodyTextTW>
      </div>
      <div className={'flex flex-row pb-2'}>
        <BodyTextTW>
          <b className={'mr-1'}>Account {data.accountResponseCodeName}:</b>
          {data.accountResponseCodeDescription}
        </BodyTextTW>
      </div>
      <div className={'flex flex-row pb-2'}>
        <BodyTextTW>
          <b className={'mr-1'}>Spruce Account Resolution:</b>
          {data.accountResponseCodeSpruceResolution}
        </BodyTextTW>
      </div>
      <div className={'flex flex-row pb-2'}>
        <BodyTextTW>
          <b className={'mr-1'}>Auth {data.authenticationResponseCodeName}:</b>
          {data.authenticationResponseCodeDescription}
        </BodyTextTW>
      </div>
      <div className={'flex flex-row pb-2'}>
        <BodyTextTW>
          <b className={'mr-1'}>Spruce Auth Resolution:</b>
          {data.authenticationResponseCodeSpruceResolution}
        </BodyTextTW>
      </div>
      <div className={'flex flex-row pb-2'}>
        <BodyTextTW>
          <b className={'mr-1'}>Reference ID:</b>
          {data.itemReferenceId}
        </BodyTextTW>
      </div>
    </div>
  );
};
